class CompareUtil {
  static get maxProducts() {
    return 3;
  }

  static getSelectedProducts() {
    const stored = theme.storageUtil.get('compare-products', true);
    const products = Array.isArray(stored) ? stored : [];
    const unique = [];

    products.forEach((product) => {
      if (!product || !product.url) return;
      const key = CompareUtil.productKey(product);
      if (!unique.some((item) => CompareUtil.productKey(item) === key)) {
        unique.push(product);
      }
    });

    return unique.slice(0, CompareUtil.maxProducts);
  }

  static setSelectedProducts(compareProducts) {
    theme.storageUtil.set('compare-products', compareProducts.slice(0, CompareUtil.maxProducts));
  }

  static productKey(product) {
    return product.handle || CompareUtil.handleFromUrl(product.url) || String(product.id);
  }

  static handleFromUrl(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return decodeURIComponent(path.split('/products/')[1] || '').split('/')[0];
    } catch (error) {
      return '';
    }
  }

  static addToCompare(productId, productUrl, productHandle, updateDom = true) {
    const compareProducts = CompareUtil.getSelectedProducts();
    const product = {
      id: String(productId || productHandle),
      url: productUrl,
      handle: productHandle || CompareUtil.handleFromUrl(productUrl)
    };
    const exists = compareProducts.some((item) => CompareUtil.productKey(item) === CompareUtil.productKey(product));

    if (exists) return true;
    if (compareProducts.length >= CompareUtil.maxProducts) return false;

    compareProducts.push(product);
    CompareUtil.setSelectedProducts(compareProducts);
    CompareUtil.updateCompareCounters(compareProducts.length);
    if (updateDom) CompareUtil.updateCompareControls();
    CompareUtil.updateShareUrl();
    return true;
  }

  static removeFromCompare(productId, updateDom = true) {
    const compareProducts = CompareUtil.getSelectedProducts().filter((product) => {
      return String(product.id) !== String(productId) && CompareUtil.productKey(product) !== String(productId);
    });

    CompareUtil.setSelectedProducts(compareProducts);
    CompareUtil.updateCompareCounters(compareProducts.length);
    if (updateDom) CompareUtil.updateCompareControls();
    CompareUtil.updateShareUrl();
  }

  static clearCompare(updateDom = true) {
    CompareUtil.setSelectedProducts([]);
    CompareUtil.updateCompareCounters(0);
    if (updateDom) CompareUtil.updateCompareControls();
    CompareUtil.updateShareUrl();
  }

  static isSelected(element) {
    const elementKey = element.dataset.productHandle || CompareUtil.handleFromUrl(element.dataset.productUrl);
    return CompareUtil.getSelectedProducts().some((product) => CompareUtil.productKey(product) === elementKey);
  }

  static updateCompareControls() {
    document.querySelectorAll('.js-compare-checkbox').forEach((checkbox) => {
      checkbox.checked = CompareUtil.isSelected(checkbox);
    });

    document.querySelectorAll('.js-compare-button').forEach((button) => {
      const selected = CompareUtil.isSelected(button);
      button.setAttribute('aria-pressed', String(selected));
      const label = button.querySelector('[data-compare-button-label]');
      if (label) {
        label.textContent = selected
          ? button.dataset.selectedLabel || 'Added to compare'
          : button.dataset.defaultLabel || 'Compare this fireplace';
      }
    });
  }

  static getCompareCount() {
    return CompareUtil.getSelectedProducts().length;
  }

  static updateCompareCounters(pCount) {
    const count = Number.isInteger(pCount) ? pCount : CompareUtil.getCompareCount();
    document.querySelectorAll('.js-compare-counter').forEach((counter) => {
      counter.textContent = count;
    });
  }

  static hydrateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const requestedHandles = (params.get('products') || '')
      .split(',')
      .map((handle) => handle.trim().toLowerCase())
      .filter((handle) => /^[a-z0-9][a-z0-9-]*$/.test(handle));
    const handles = [];

    requestedHandles.forEach((handle) => {
      if (handles.length < CompareUtil.maxProducts && !handles.includes(handle)) handles.push(handle);
    });

    if (!handles.length) return;

    CompareUtil.setSelectedProducts(handles.map((handle) => ({
      id: handle,
      handle,
      url: `/products/${handle}`
    })));
  }

  static async hydrateDedicatedPage() {
    const pageProducts = window.TEFS_COMPARE_PRODUCTS;
    const selects = [
      document.getElementById('tefsCompareOne'),
      document.getElementById('tefsCompareTwo'),
      document.getElementById('tefsCompareThree')
    ];

    if (!Array.isArray(pageProducts) || selects.some((select) => !select)) return;

    const selections = CompareUtil.getSelectedProducts();
    if (!selections.length) return;

    const findPageProduct = (handle) => pageProducts.find((product) => {
      return (product.handle || CompareUtil.handleFromUrl(product.url)) === handle;
    });

    for (let index = 0; index < selections.length; index += 1) {
      const selection = selections[index];
      const handle = CompareUtil.productKey(selection);
      let pageProduct = findPageProduct(handle);

      if (!pageProduct) {
        try {
          const response = await fetch(new URL(selection.url, window.location.origin), { credentials: 'same-origin' });
          if (!response.ok) continue;

          const template = document.createElement('template');
          template.innerHTML = await response.text();
          const dataScript = template.content.querySelector('[data-premium-compare-product]');
          if (!dataScript) continue;

          const product = JSON.parse(dataScript.textContent);
          pageProduct = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            vendor: product.brand,
            type: '',
            url: product.url,
            image: product.image && product.image.url,
            price: product.price,
            compareAtPrice: product.compareAtPrice,
            available: product.available,
            description: '',
            searchText: `${product.brand || ''} ${product.title || ''} ${product.sku || ''}`.toLowerCase(),
            specs: {
              width: product.specs.overallWidth && product.specs.overallWidth.display,
              height: product.specs.overallHeight && product.specs.overallHeight.display,
              depth: product.specs.overallDepth && product.specs.overallDepth.display,
              heatingCapacity: product.specs.heatingCapacity,
              voltage: product.specs.voltage,
              amps: product.specs.amps,
              installation: product.specs.installationType || product.specs.installation,
              viewingStyle: product.specs.viewingStyle,
              bestFor: product.specs.bestFor,
              flameColors: Array.isArray(product.specs.flameColours)
                ? product.specs.flameColours.join(', ')
                : product.specs.flameColours,
              smartControl: product.specs.smartControl,
              heaterLocation: product.specs.heaterLocation,
              mediaType: product.specs.mediaType,
              warranty: product.specs.warranty
            }
          };
          pageProducts.push(pageProduct);
        } catch (error) {
          continue;
        }
      }

      const select = selects[index];
      const value = String(pageProduct.id);
      if (!Array.from(select.options).some((option) => option.value === value)) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = pageProduct.vendor
          ? `${pageProduct.vendor} — ${pageProduct.title}`
          : pageProduct.title;
        select.appendChild(option);
      }
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  static comparisonUrl() {
    const handles = CompareUtil.getSelectedProducts()
      .map((product) => CompareUtil.productKey(product))
      .filter(Boolean);
    return `/pages/compare-electric-fireplaces?products=${encodeURIComponent(handles.join(','))}`;
  }

  static updateShareUrl() {
    if (!window.location.pathname.includes('/pages/compare-electric-fireplaces')) return;
    const products = CompareUtil.getSelectedProducts();
    const url = products.length ? CompareUtil.comparisonUrl() : window.location.pathname;
    window.history.replaceState({}, '', url);
  }
}

/* global SideDrawer */

if (!customElements.get('compare-drawer')) {
  class CompareDrawer extends SideDrawer {
    constructor() {
      super();
      this.openDrawerButton = document.querySelector('.js-open-compare-drawer');
      this.compareBasketArea = this.querySelector('.js-compare-basket');
      this.loadingSpinner = this.querySelector('.loading-spinner');
      this.doCompareButton = this.querySelector('.js-trigger-compare');
      this.clearButton = this.querySelector('.js-clear-compare');
      this.message = this.querySelector('.js-compare-message');
      this.copy = CompareDrawer.readCopy();
      this.maxCompare = Math.min(Number(this.dataset.maxCompare) || 3, CompareUtil.maxProducts);
      this.compareModal = document.querySelector('.js-compare-modal');
      this.init();
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.clickHandler);
      document.removeEventListener('change', this.changeHandler);
      document.removeEventListener('on:facet-filters:updated', this.filterHandler);
    }

    init() {
      CompareUtil.hydrateFromUrl();
      CompareUtil.hydrateDedicatedPage();
      CompareUtil.updateCompareControls();
      CompareUtil.updateCompareCounters();
      this.toggleCompareButton();
      this.updateBasketState();

      setTimeout(() => {
        this.openDrawerButton.removeAttribute('style');
        this.openDrawerButton.classList.add('transition-ready');
      }, 300);

      this.compareModal.querySelector('.details-modal').classList.remove('hidden');

      if (window.location.pathname.includes('/pages/compare-electric-fireplaces') && CompareUtil.getCompareCount() >= 2) {
        customElements.whenDefined('compare-modal').then(() => {
          setTimeout(() => {
            this.compareModal.dispatchEvent(new CustomEvent('on:product-compare-modal:open'));
          }, 100);
        });
      }
    }

    bindEvents() {
      this.clickHandler = this.handleClick.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.filterHandler = CompareUtil.updateCompareControls;

      document.addEventListener('click', this.clickHandler);
      document.addEventListener('change', this.changeHandler);
      document.addEventListener('on:facet-filters:updated', this.filterHandler);
      this.doCompareButton.addEventListener('click', this.handleDoCompareClick.bind(this));
      this.clearButton.addEventListener('click', this.handleClearCompareClick.bind(this));
    }

    announce(message) {
      this.message.textContent = message;
      clearTimeout(this.messageTimer);
      this.messageTimer = setTimeout(() => {
        this.message.textContent = '';
      }, 5000);
    }

    toggleCompareButton() {
      const count = CompareUtil.getCompareCount();
      this.openDrawerButton.classList.toggle('is-out', count === 0);
      this.openDrawerButton.setAttribute('aria-expanded', String(this.classList.contains('is-open')));
    }

    toggleProduct(productData) {
      const selected = CompareUtil.getSelectedProducts().some((product) => {
        return CompareUtil.productKey(product) === (productData.productHandle || CompareUtil.handleFromUrl(productData.productUrl));
      });

      if (selected) {
        const selectedProduct = CompareUtil.getSelectedProducts().find((product) => {
          return CompareUtil.productKey(product) === (productData.productHandle || CompareUtil.handleFromUrl(productData.productUrl));
        });
        CompareUtil.removeFromCompare(selectedProduct.id, true);
      } else {
        const added = CompareUtil.addToCompare(
          productData.productId,
          productData.productUrl,
          productData.productHandle,
          true
        );
        if (!added) {
          this.announce(theme.strings.compare.limit.replace('[quantity]', this.maxCompare));
        }
      }

      this.toggleCompareButton();
      this.updateBasketState();
    }

    handleClick(evt) {
      const compareButton = evt.target.closest('.js-compare-button');
      const removeButton = evt.target.closest('.js-compare-basket-remove');

      if (evt.target.closest('.js-open-compare-drawer')) {
        if (this.openDrawerButton.classList.contains('is-open')) {
          this.close();
        } else {
          this.open(this.openDrawerButton);
        }
      } else if (compareButton) {
        this.toggleProduct(compareButton.dataset);
      } else if (removeButton) {
        CompareUtil.removeFromCompare(removeButton.dataset.productId, true);
        const basketItem = removeButton.closest('[id^="compare-basket-"]') || removeButton.closest('.card');
        if (basketItem) basketItem.remove();
        this.toggleCompareButton();
        this.updateBasketState();
      } else if (evt.target === this.overlay || evt.target.closest('.js-close-compare')) {
        this.close();
      }
    }

    handleChange(evt) {
      if (!evt.target.classList.contains('js-compare-checkbox')) return;

      const productData = evt.target.dataset;
      if (evt.target.checked) {
        const added = CompareUtil.addToCompare(
          productData.productId,
          productData.productUrl,
          productData.productHandle,
          true
        );
        if (!added) {
          evt.target.checked = false;
          this.announce(theme.strings.compare.limit.replace('[quantity]', this.maxCompare));
        }
      } else {
        const selected = CompareUtil.getSelectedProducts().find((product) => {
          return CompareUtil.productKey(product) === (productData.productHandle || CompareUtil.handleFromUrl(productData.productUrl));
        });
        if (selected) CompareUtil.removeFromCompare(selected.id, true);
      }

      this.toggleCompareButton();
      this.updateBasketState();
    }

    handleDoCompareClick() {
      if (CompareUtil.getCompareCount() < 2) {
        this.announce(theme.strings.compare.empty);
        return;
      }

      window.location.assign(CompareUtil.comparisonUrl());
    }

    handleClearCompareClick() {
      CompareUtil.clearCompare(true);
      this.compareBasketArea.innerHTML = '';
      this.toggleCompareButton();
      this.updateBasketState();
      this.close();
    }

    async open(opener) {
      opener.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      this.overlay.classList.add('overlay--over-nav', 'js-compare-overlay');
      super.open(opener);
      await this.renderCompareBasket();
    }

    close() {
      this.openDrawerButton.classList.remove('is-open');
      this.openDrawerButton.setAttribute('aria-expanded', 'false');
      this.overlay.classList.remove('overlay--over-nav', 'js-compare-overlay');
      super.close();
    }

    updateBasketState() {
      const compareCount = CompareUtil.getCompareCount();
      this.doCompareButton.disabled = compareCount < 2;
      this.doCompareButton.setAttribute('aria-disabled', String(compareCount < 2));

      this.compareBasketArea.querySelectorAll('.js-select-more, .js-select-one').forEach((element) => element.remove());
      const continueButton = `<button type="button" class="js-close-compare link">${theme.strings.compare.continue}</button>`;

      if (compareCount === 1) {
        this.compareBasketArea.insertAdjacentHTML('beforeend', `<div class="compare-prompt text-sm js-select-more">${theme.strings.compare.more} ${continueButton}</div>`);
      } else if (compareCount === 0) {
        this.compareBasketArea.insertAdjacentHTML('beforeend', `<div class="compare-prompt text-sm js-select-one">${theme.strings.compare.empty} ${continueButton}</div>`);
      }
    }

    async renderCompareBasket() {
      const compareProducts = CompareUtil.getSelectedProducts();
      this.loadingSpinner.hidden = false;
      this.loadingSpinner.removeAttribute('aria-hidden');
      this.compareBasketArea.classList.remove('revealable--in');
      this.compareBasketArea.innerHTML = '';

      try {
        const basketProducts = await CompareDrawer.getBasketProducts(compareProducts);
        basketProducts.forEach(({ html, selectionId }) => {
          const template = document.createElement('template');
          template.innerHTML = html.trim();
          const removeButton = template.content.querySelector('.js-compare-basket-remove');
          if (removeButton) removeButton.dataset.productId = selectionId;
          this.compareBasketArea.appendChild(template.content);
        });
      } catch (error) {
        this.announce(this.copy.loadError);
      }

      this.loadingSpinner.hidden = true;
      this.loadingSpinner.setAttribute('aria-hidden', 'true');
      this.compareBasketArea.classList.add('revealable--in');
      this.updateBasketState();
    }

    static async getBasketProducts(compareProducts) {
      return Promise.all(compareProducts.map(async (product) => {
        const url = new URL(product.url, window.location.origin);
        url.searchParams.set('sections', 'product-compare-basket');
        const response = await fetch(url);
        if (!response.ok) throw new Error();
        const sections = await response.json();
        return { html: sections['product-compare-basket'] || '', selectionId: product.id };
      }));
    }

    static readCopy() {
      const script = document.getElementById('premium-compare-copy');
      return script ? JSON.parse(script.textContent) : {};
    }
  }

  customElements.define('compare-drawer', CompareDrawer);
}
